(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-exo-catalog]:not([data-enhanced])').forEach(root => {
      root.dataset.enhanced = 'true';
      const sidebar = root.querySelector('[data-exo-sidebar]');
      const panel = root.querySelector('.exo-sidebar__panel');
      const trigger = sidebar?.querySelector('summary');
      const backdrop = root.querySelector('.exo-sidebar__backdrop');
      if (!sidebar || !panel || !trigger || !backdrop) return;
      const mobile = matchMedia('(max-width:749px)');
      if (panel.id) trigger.setAttribute('aria-controls', panel.id);
      let wasOpen = false;
      const sync = () => {
        const open = mobile.matches && sidebar.open;
        trigger.setAttribute('aria-expanded', String(sidebar.open));
        backdrop.hidden = !open;
        document.body.classList.toggle('exo-drawer-open', open);
        if (open) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          panel.setAttribute('aria-label', 'Product categories');
          if (!wasOpen) panel.querySelector('button')?.focus();
        } else {
          panel.removeAttribute('role');panel.removeAttribute('aria-modal');panel.removeAttribute('aria-label');
        }
        wasOpen = open;
      };
      const close = () => { sidebar.open = false; sync(); trigger.focus(); };
      root.querySelectorAll('[data-exo-close]').forEach(button => button.addEventListener('click', close));
      sidebar.addEventListener('toggle', sync);
      root.addEventListener('keydown', event => {
        if (!mobile.matches || !sidebar.open) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const nodes = [...panel.querySelectorAll('a[href],button:not([disabled])')];
          const first = nodes[0], last = nodes[nodes.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      const mode = () => { sidebar.open = !mobile.matches; sync(); };
      if (mobile.addEventListener) mobile.addEventListener('change', mode);
      else mobile.addListener(mode);
      mode();

    });
  }
  function updateVariant(select) {
    const option = select.selectedOptions[0];
    if (!option) return;
    const info = select.closest('.pdp-info');
    const price = info?.querySelector('[data-exo-variant-price]');
    const stock = info?.querySelector('[data-variant-stock]');
    const submit = select.form?.querySelector('.add-btn');
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price;
    if (stock) stock.textContent = available ? 'Available' : 'Sold out';
    if (submit) {
      submit.dataset.wasDisabled = String(!available);
      submit.disabled = !available || select.form.dataset.loading === 'true';
      submit.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }
  }
  document.querySelectorAll('.variant-select').forEach(updateVariant);
  document.addEventListener('change', event => {
    if (event.target.matches('.variant-select')) updateVariant(event.target);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('.exo-sort');
    if (!form || !form.querySelector('[name="sort_by"]')) return;
    event.preventDefault();
    const url = new URL(location.href);
    url.searchParams.set('sort_by', new FormData(form).get('sort_by'));
    url.searchParams.delete('page');location.assign(url);
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('exo-drawer-open'));
  const header = document.querySelector('.site-header');
  if (header && window.ResizeObserver) {
    const updateHeaderHeight = () => document.documentElement.style.setProperty('--exo-header', `${header.offsetHeight + 16}px`);
    new ResizeObserver(updateHeaderHeight).observe(header);
    updateHeaderHeight();
  }
})();
